export default __webpack_public_path__ + "static/media/digitalia.640b0c26.PNG";